/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Analyzer API
 * Analyzer API gateway
 * OpenAPI spec version: 1.0.0
 */

export type EmailQuestionnairePdfBadRequestErrorCode =
  (typeof EmailQuestionnairePdfBadRequestErrorCode)[keyof typeof EmailQuestionnairePdfBadRequestErrorCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailQuestionnairePdfBadRequestErrorCode = {
  client_email_missing: "client_email_missing",
  client_birth_date_missing: "client_birth_date_missing",
} as const;
